const withPrefix = (value, prefix) => {
  if (Array.isArray(value)) {
    return value.map((item) => withPrefix(item, prefix))
  }
  if (typeof value !== 'string') return value
  if (value.startsWith('http://') || value.startsWith('https://')) return value
  if (value.startsWith(`${prefix}/`)) return value
  return `${prefix}/${value}`
}

const USER_ENDPOINTS = {
  LOGIN: 'login',
  SOCIAL_LOGIN: 'social_login',
  SOCIAL_LOGIN_CANDIDATES: ['social_login'],
  REGISTER: 'register',
  GET_PROFILE: 'get_profile',
  LOGIN_RESET: 'login_reset',
  LOGIN_RESET_VERIFY: 'login_reset_verify',
  FORGOT_PASSWORD_CANDIDATES: ['login_reset', 'forgot_password', 'reset_password'],
  FORGOT_PASSWORD_VERIFY_CANDIDATES: ['login_reset_verify', 'forgot_password_verify', 'reset_password_verify'],
  UPDATE_PROFILE: 'edit_profile',
  DELETE_ACCOUNT_CANDIDATES: ['delete_account', 'delete_profile', 'account_delete'],
  CHANGE_PASSWORD: 'changepwd',
  MORE_APPS: 'live_apps_inviteapp',

  GET_INVITATIONS: 'get_events_prod_signed',
  GET_EVENT_TYPES: 'get_event_type_settings',
  GET_INVITATION_DETAIL: 'get_members_invitation_prod',
  GET_RECEIVED_INVITATION_DETAIL: 'get_detailed_event_prod',
  GET_NOTES_MEMBERS_EVENT_DETAIL: 'get_notes_members_event_detail',
  GET_GUESTS_LIST: 'guests_List',
  ADD_GUEST: 'add_members_invitation',
  EDIT_GUEST: 'update_contact',
  DELETE_GUEST: 'delete_contact',
  DELETE_GUEST_INVITATION: 'delete_member_invitation',
  GET_COHOSTS: 'friends',
  UPDATE_COHOSTS: 'invitation_cohosts_update',
  ADD_GUEST_AUTO: 'add_members_invitation_auto',
  GET_RECEIVED_INVITATIONS_PROFILE: 'get_profile_events_prod',

  GET_RECEIVED_INVITATIONS: 'get_invites_user_prod',
  GET_EVENTS_DISCOVERY: 'get_events_discovery',
  UPDATE_INVITATION_DISCOVERY_INTEREST: 'update_invitation_discovery_interest',
  GET_ALBUMS: 'get_album_events',
  GET_RECEIVED_ALBUMS: 'get_invites_recieved_album_user',
  GET_ALBUM_PUBLIC: 'get_album_public_photos_event',
  GET_ALBUM_PRIVATE: 'get_album_private_photos_event',
  UPLOAD_ALBUM: 'upload_album_photo_event',
  DELETE_ALBUM_IMAGE: 'delete_image_album_event',
  CHECK_HOST: 'check_host_invitation_login',
  GET_CONNECTIONS: 'invite_connections',
  GET_CONNECTIONS_STATS: 'invite_connections_rsvp_status',
  GET_CONNECTIONS_EVENTS: 'invite_connections_past',

  SAVE_FEEDBACK: 'share_feedback_event',
  UPDATE_FEEDBACK: 'update_feedback_event',
  FEEDBACK_LIST: 'get_feedbacks_event',

  CREATE_INVITATION: 'add_event_prod_presigned',
  UPDATE_INVITATION: 'update_event_prod_presigned',
  DELETE_INVITATION: 'delete_event',

  NEARBY_VENDORS: 'nearby_photographers',
  SEND_INVITE_VENDORS: 'send_invite_vendors',
  UPDATE_INVITE_VENDOR_CATEGORIES: 'update_invite_vendor_categories',
  INVITE_HIRED_VENDORS: 'invite_hired_vendors',
  DELETE_HIRED_VENDORS: 'delete_invite_vendor',

  GET_POSTER_CATEGORIES: 'list_category_gif',
  GET_POSTERS: 'list_images_gif_category',
  GET_GIFS: 'https://tenor.googleapis.com/v2/search',
  GET_GIFHY: 'https://api.giphy.com/v1/gifs/search',

  SEND_INVITE: 'send_invite_member',
  RESEND_INVITE_MEMBER: 'resend_invite_member',
  SEND_INVITE_PHONE: 'send_invite_member_phone',
  RESEND_INVITE_MEMBER_PHONE: 'resend_invite_member_phone',

  CREATE_CONTACT_NEW: 'add_other_contact_new',

  SEND_ENQUIRY: 'send_invite_enquiry',
  SEND_VENUE_ENQUIRY: 'send_enquiry',
  SEND_ENQUIRY_SERVICE_VENDOR: 'send_enquiry_service_vendor',
  SEND_ENQUIRY_SERVICE_VENDOR_VERIFY: 'send_enquiry_service_vendor_verify',
  SEND_ENQUIRY_VENUE_VERIFY: 'send_enquiry_venue_verify',
  ENQUIRY_CATEGORIES_LIST: 'list_contextual_category_enquiry',
  UPDATE_RSVP: 'update_adult_child_members_invitation',
  UPDATE_RSVP_GUEST: 'update_rsvp_invitation',
  UPDATE_RSVP_LOGIN: 'update_rsvp_invitation_login',
  GET_WEB_COUNT: 'get_web_counts_invitation',
  CHECK_EXIST_INVITATION: 'check_member_existed_invitation',

  UPDATE_RECEIVED_RSVP: 'update_invite_user',
  UPDATE_EVENT_SETTINGS: 'update_event_settings',
  GET_INVITE_MODULES: 'get_invite_modules',
  GET_EVENT_POSTS: 'get_posts_invite',
  ADD_EVENT_POST: 'add_post_invite',
  DELETE_EVENT_POST: 'delete_post_invite',
  LIKE_EVENT_POST: 'like_post_invite',
  UPDATE_POLL_EVENT_POST: 'update_poll_post_invite',
  GET_VOTES_EVENT_POST: 'get_votes_post_invite',
  VIEW_EVENT_POST_COMMENTS: 'view_comments_post_invite',
  ADD_EVENT_POST_COMMENT: 'add_comment_post_invite',

  CONTACTS_LIST: 'myContactsList',
  FRIENDS_LIST: 'friends',
  ENQUIRIES_LIST: 'get_invite_enquiries',
  ENQUIRY_DETAIL: 'get_invite_enquiry_details',

  GET_VENDORS: 'list_sellers_contextual_category',
  GET_CATEGORIES_LIST: 'list_contextual_category',
  VENDOR_DETAIL: 'businessdetail',
  VENDOR_PRODUCTS: 'business_products',
  VENDOR_PACKAGES: 'get_packages',
  GET_VENUES_INVITE: 'get_venues_invite',
  GET_VENUE_DETAIL_INVITE: 'get_venue_detail_invite',
  GET_SERVICE_VENDORS_INVITE: 'get_service_vendors_invite',
  GET_SERVICE_VENDOR_DETAIL_INVITE: 'get_service_vendor_detail_invite',

  SCANNED: 'get_users_event_qrscan',
  SAVE_SHARE_GUESTS: 'grant_album_access_invite_friends',
  UPDATE_ALBUM_SETTINGS: 'update_settings_album',
  UPLOAD_PERMISSIONS: 'invitation_album_upload_members_update',
  REMOVE_ACCESS: 'remove_invite_album_access',

  SEARCH_USER_INFO: 'search_users_info',
  SEND_REQUEST: 'send_request_contact',
  CANCEL_REQUEST: 'cancel_request',
  APPROVE_REQUEST: 'accept_request_contact'
}

USER_ENDPOINTS.GUESTS_LIST = USER_ENDPOINTS.GET_GUESTS_LIST
USER_ENDPOINTS.CREATE_CONTACT = USER_ENDPOINTS.ADD_GUEST
USER_ENDPOINTS.UPDATE_CONTACT = USER_ENDPOINTS.EDIT_GUEST
USER_ENDPOINTS.DELETE_CONTACT = USER_ENDPOINTS.DELETE_GUEST
USER_ENDPOINTS.UPDATE_COHOST = USER_ENDPOINTS.UPDATE_COHOSTS
USER_ENDPOINTS.GET_EVENT_DETAIL = USER_ENDPOINTS.GET_INVITATION_DETAIL
USER_ENDPOINTS.DETAIL_INVITATION = USER_ENDPOINTS.GET_INVITATION_DETAIL

Object.keys(USER_ENDPOINTS).forEach((key) => {
  USER_ENDPOINTS[key] = withPrefix(USER_ENDPOINTS[key], 'api_u')
})

export default USER_ENDPOINTS
